import { render, staticRenderFns } from "./PaymentInfoPanel.vue?vue&type=template&id=585f92fc&"
import script from "./PaymentInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./PaymentInfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports